var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"width":"100vw"}},[_c('vue-headful',{attrs:{"title":_vm.$route.name ? _vm.$route.name + ' | iTurnier.de' : 'iTurnier.de'}}),(!_vm.user.loader)?_c('div',[_c('router-view',{attrs:{"stlye":"width: 100vw;"}})],1):_vm._e(),(_vm.user.loader)?_c('Loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }